import GenericLayout from '@homepage/components/GenericLayout';
import PageImage from '@homepage/components/PageImage';
import About from '@homepage/pages/martial-arts-training/About';
import Results from '@homepage/pages/martial-arts-training/Results';
import Testi from '@homepage/pages/martial-arts-training/Testi';
import TrainingInfo from '@homepage/pages/martial-arts-training/TrainingInfo';
import { PageImageId } from '@homepage/types/page-image';
import { FC } from 'react';

import C2A from './C2A';
import Schedules from './Schedules';

const Training: FC = () => {
  return (
    <GenericLayout title='Training'>
      <PageImage id={PageImageId.Training} />

      <Schedules />
      <TrainingInfo />
      <About />
      <Results />
      <C2A />
      <Testi />
    </GenericLayout>
  );
};

export default Training;
